"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Account from "../api/account";
import classNames from "classnames";
import presenceService from "./presence_service_next_gen";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import Honeybadger from "@honeybadger-io/js";
function getList(props) {
  return presenceService.getOtherUsers(props);
}
function flowMode(props) {
  if (props.location && props.location.query) {
    const onDone = props.location.query.onDone || "";
    return onDone.includes("inFlowMode=true") || onDone.includes("newFlowMode");
  }
  return false;
}
function viewedByText(props) {
  return props.carrierId ? Account.carrierTerm() + " viewed by" : "Currently viewed by";
}
function redirectToDashboard(props) {
  ToDashboardWithFilters(props.location);
}
class PresenceList extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      hasAlertedForDuplicatePresence: false,
      hidden: false,
      users: getList(this.props)
    });
    __publicField(this, "alertForDuplicatePresence", () => {
      if (!this.state.hasAlertedForDuplicatePresence) {
        Honeybadger.notify("Flow Mode - Duplicate Presence", {
          fingerprint: "flow_mode_duplicate_presence",
          context: {
            batchId: this.props.batchId,
            currentUser: {
              id: presenceService.user.id,
              name: presenceService.user.name,
              displayName: presenceService.user.display_name
            },
            emailId: this.props.emailId,
            loadId: this.props.loadId,
            path: this.props.location.pathname,
            users: this.state.users
          },
          message: `${this.state.users.length} users detected`
        });
        this.setState({ hasAlertedForDuplicatePresence: true });
      }
    });
    __publicField(this, "updateList", () => {
      this.setState({ users: getList(this.props) });
    });
    __publicField(this, "hide", () => {
      if (!this.props.inline) {
        this.setState({ hidden: true });
      }
    });
    __publicField(this, "show", (e) => {
      this.setState({ hidden: false });
      e.stopPropagation();
    });
  }
  componentDidMount() {
    $(presenceService).on("presence_service:updated", this.updateList);
    this.updateList();
  }
  componentDidUpdate() {
    if (flowMode(this.props) && this.state.users.filter(
      (x) => x.name !== presenceService.user.name && x.name !== presenceService.user.display_name
    ).length > 0) {
      this.alertForDuplicatePresence();
    }
  }
  componentWillUnmount() {
    $(presenceService).off("presence_service:updated", this.updateList);
  }
  render() {
    if (this.state.users.length === 0) {
      return /* @__PURE__ */ jsx("div", { "data-component": "PresenceList" });
    }
    var whoClasses = classNames({
      presence__who: true,
      hidden: this.state.hidden,
      presence__carrier: this.props.carrierId
    });
    var linkClasses = classNames({
      presence__link: true,
      hidden: this.state.hidden
    });
    var showClasses = classNames({
      presence__show: true,
      visible: this.state.hidden
    });
    var containerClasses = classNames({
      presence__container: !this.props.inline,
      "presence__container--inline": this.props.inline
    });
    if (this.props.className) {
      containerClasses += " " + this.props.className;
    }
    return /* @__PURE__ */ jsxs("div", { className: containerClasses, children: [
      /* @__PURE__ */ jsx("div", { className: whoClasses, onClick: this.hide, children: /* @__PURE__ */ jsxs("span", { children: [
        viewedByText(this.props),
        ":\xA0",
        _.map(this.state.users, function(u) {
          return u.name;
        }).join(", ")
      ] }) }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: linkClasses,
          onClick: () => redirectToDashboard(this.props),
          children: flowMode(this.props) ? "Skip to Next Item" : "Back to Dashboard"
        }
      ),
      /* @__PURE__ */ jsx("div", { className: showClasses, onClick: this.show, children: "+" })
    ] });
  }
}
export default PresenceList;
